// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ebe1ced","453":"d9d3eae6","455":"d1ec330e","977":"1503c216"}[chunkId] + ".chunk.js";
};